import { Component, ElementRef, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular'
import { PagesProvider } from '../../providers/pages/pages.provider';
import { TeacherProvider } from '../../providers/teacher/teacher.provider';
import { Page } from '../../models/page';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Filters, FilterSection, FilterItem } from 'src/app/components/resources-filter/resources-filter.component';
import { plainToClass } from 'class-transformer';
import { ResourcesBase } from '../resources/resources-base.page';
import { ResourcesCssService } from '../resources/resources-css.service'
import { WindowService } from '../../services/window.service'
import { ResourceSortItem } from 'src/app/components/resources-header/resources-header.component';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-pages',
  templateUrl: './pages.page.html',
  styleUrls: ['./pages.page.scss'],
})
export class PagesPage implements OnInit {

  url: String
  page: Page = Page.defaults()
  pages: Page[]
  viewDisplayed: boolean = false
  pageContent: any
  pageColor: String

  constructor(element: ElementRef,
              private pagesProvider: PagesProvider,
              private teacherProvider: TeacherProvider,
              public resourcesCssService: ResourcesCssService,
              public windowService: WindowService,
              private popoverCtrl: PopoverController,
              private router: Router,
              private route: ActivatedRoute,
              private sanitizer: DomSanitizer) {

    // Remove the pages/ element of the url segments
    this.url = this.router.url.slice(7)

    // this.teacherProvider.getTeacher().subscribe(t => {
    //   if (this.page != null && this.page.type === 'resource') {
    //     this.pages = t.resourcePages
    //   } else {
    //     this.pages = t.pages
    //   }
    //   this.populatePageColor(this.pages)
    // })

    this.pagesProvider.getPage(this.url).subscribe(r => {
      this.page = r
      this.pageContent = this.sanitizer.bypassSecurityTrustHtml(this.page.content)

      if (this.page != null && this.page.type === 'resource') {
        this.pages = this.teacherProvider.teacher.resourcePages
      } else {
        this.pages = this.teacherProvider.teacher.pages
      }
      this.populatePageColor(this.pages)
      this.viewDisplayed = true
    })
  }

  ngOnInit() {
    this.windowService.width$.subscribe((value: number) =>  this.resourcesCssService.width = value)

    // below lines of code will trick browser to refresh the page data
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
  }

  populatePageColor(pages: Page[]) {
    pages.forEach((value: Page) => {
      if (value.slug === this.url) {
        if (value.type !== 'resource') {
          this.pageColor = value.color
        } else {
          this.pageColor = '1dca7f'
        }
        return
      }
      if (value.pages.length > 0) {
        this.populatePageColor(value.pages)
      }
    })
  }

  get pageWidth(): string {
    return this.page.width === 'full' ? 'full-page-width' : ''
  }

  get isResourcePage(): boolean {
    if (this.page === null) {
      return false
    }
    return this.page.type === 'resource'
  }
}
